import "./Clients.module.css";
import Header from "@/reusable_sections/Header";
import ClientsHero from "./sections/ClientsHero";
import About from "./sections/About";
import InfoColumns from "./sections/InfoColumns";
import Profile from "./sections/Profile";
import ProfileCopy from "./sections/ProfileCopy";
import RealEstateCleaning from "./sections/RealEstateCleaning";
import ClientLogos from "./sections/ClientLogos";
import ClientVideos from "./sections/ClientVideos";
import VideoGallery from "./sections/VideoGallery";
import ImageAndTextSplit from "./sections/ImageAndTextSplit";
import SplitLayoutWithImage from "./sections/SplitLayoutWithImage";
import SplitLayoutWithImageCopy from "./sections/SplitLayoutWithImageCopy";
import SplitContentWithImage from "./sections/SplitContentWithImage";
import MomentumMethodology from "./sections/MomentumMethodology";
import MomentumMethodologyCopy from "./sections/MomentumMethodologyCopy";
import MomentumMethodologyCopyCopy from "./sections/MomentumMethodologyCopyCopy";
import MomentumMethodologyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopy2 from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopy2";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy";
import MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy from "./sections/MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy";
import ModernMeetup from "./sections/ModernMeetup";
import TextContentBlocks from "./sections/TextContentBlocks";
import Footer from "@/reusable_sections/Footer";
export default function ClientsPage() {
  return <div>
      <Header />
      <ClientsHero />
      <About />
      <InfoColumns />
      <Profile />
      <ProfileCopy />
      <RealEstateCleaning />
      <ClientLogos />
      <ClientVideos />
      <VideoGallery />
      <ImageAndTextSplit />
      <SplitLayoutWithImage />
      <SplitLayoutWithImageCopy />
      <SplitContentWithImage />
      <MomentumMethodology />
      <MomentumMethodologyCopy />
      <MomentumMethodologyCopyCopy />
      <MomentumMethodologyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopy2 />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy />
      <MomentumMethodologyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopyCopy />
      <ModernMeetup />
      <TextContentBlocks />
      <Footer />
    </div>;
}